<script lang="ts">
  export let type: string = 'button';
  export let loading = false;
  export let label: string | undefined = undefined;
  export let disabled = false;

  import { createEventDispatcher } from 'svelte';
  let dispatch = createEventDispatcher<{ click: MouseEvent }>();

  let delayedLoading = false;
  let to: number;

  $: {
    if (loading) {
      delayedLoading = loading;
    } else {
      clearTimeout(to);

      to = setTimeout(() => {
        delayedLoading = false;
      }, 300) as any as number;
    }
  }
</script>

<button
  {type}
  on:click={e => dispatch('click', e)}
  aria-label={label}
  title={label}
  disabled={disabled || loading}
>
  <slot />

  <div class="loop_loading_wrapper{loading ? ' loop_active' : ''}">
    {#if delayedLoading}
      <div class="loop_loading" />
    {/if}
  </div>
</button>

<style>
  button {
    height: 36px;
    width: 100%;
    border-radius: 8px;
    transition: all 0.3s;
    border: solid var(--loop-primary) 1px;
    background: var(--loop-primary);
    padding: 0px;
    color: var(--loop-primaryText);
    font-weight: 500;
    position: relative;
  }

  button:hover,
  button:focus {
    background: var(--loop-background);
    color: var(--loop-primaryTextHover);
  }

  @keyframes loop_spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .loop_loading_wrapper {
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background: var(--loop-background);
    border-radius: 7px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s;
  }

  .loop_loading_wrapper.loop_active {
    opacity: 1;
    pointer-events: all;
  }

  .loop_loading {
    border: 3px solid var(--loop-accent1);
    border-top: 3px solid var(--loop-primary);
    border-radius: 50%;
    width: 14px;
    height: 14px;
    animation: loop_spin 2s linear infinite;
  }
</style>
